import React from 'react';
import classNames from 'classnames';
import { withLabel as Logo } from './logo.jsx';

const Intro = props => {
  return <div className={classNames('intro', {
      'intro--visible': props.visible
    })}>
    <div className='container'>
      <Logo />
    </div>
  </div>
}
export default Intro;
